export default __webpack_public_path__ + "static/reactathon-footer-logo-b49ed27a4c4ccc5c29433d3ebe4e3252.svg";